module.exports = __webpack_public_path__ + "img/Remove-icon.9701684b.svg";